import * as React from "react"

import { cn } from "./lib/utils"

function Card({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card"
      className={cn(
        // ops-hub deviates from shadcn defaults to match the v0.3 Tremor
        // Raw Card (which is the visual baseline the user is comparing
        // against on dev-app.chainservice.io):
        //
        //   shadcn default:  flex flex-col gap-6 rounded-xl border bg-card
        //                    py-6 text-card-foreground shadow-sm
        //   ops-hub:         relative rounded-lg border bg-card
        //                    text-card-foreground shadow-xs + consumer p-N
        //
        // Differences vs shadcn default:
        //   - rounded-lg (8px) instead of rounded-xl (12px) — softer corners
        //   - shadow-xs instead of shadow-sm — subtler lift
        //   - no flex/gap/py — consumer controls layout & padding via
        //     className. CardHeader / CardContent still bring their own
        //     px-6 / py-6 paddings when consumers opt into the
        //     compositional API.
        "relative rounded-lg border border-border bg-card text-card-foreground shadow-xs",
        className
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        className
      )}
      {...props}
    />
  )
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-title"
      className={cn("leading-none font-semibold", className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn("text-sm text-muted-foreground", className)}
      {...props}
    />
  )
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        className
      )}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("px-6", className)}
      {...props}
    />
  )
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn("flex items-center px-6 [.border-t]:pt-6", className)}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
}
